import React, { useState, useEffect } from 'react'
import Loader from "common/components/Loader";
import Header from "common/js/header/header";
import { toast, ToastContainer } from "react-toastify";
import { getEligibilityReportSvc } from 'sms/tt/eligibilityReport/js/eligibilityReportSvc';
import UploadEligibility from './uploadEligibility';


const EligibilityReport = () => {
    const [loader, setLoader] = useState("none");
    const [opacity, setOpacity] = useState(1);
    const [randNo, setRandNo] = useState(0);
    const [sybId, setSybId] = useState(0)
    const [subId, setSubId] = useState(0)
    const [sybSubId, setSybSubId] = useState('')
    const [rowIdx, setRowIdx] = useState(0)
    const [lstEligibility, setLstEligibility] = useState([])
    const [lstEligibilityFiltered, setLstEligibilityFiltered] = useState([])
    const [teacherFiltered, setTeacherFiltered] = useState('')
    const [subjectFiltered, setSubjectFiltered] = useState('')
    const [classFiltered, setClassFiltered] = useState('');

    const [eligibilityExcelFile, setEligibilityExcelFile] = useState(null);


    useEffect(() => {
        getEligibilityReport()
    }, [randNo])

    function getEligibilityReport() {
        getEligibilityReportSvc(eligibilityReportResponse)
    }

    function eligibilityReportResponse(data) {
        var obj = data;
        // console.log("obj in eligibilityReportResponse", obj);
        if (obj.status === "Success") {
            setLstEligibility(obj.lstEligibility)
            setLstEligibilityFiltered(obj.lstEligibility)
        } else {
            toast.error(obj.message);
        }
    }
    const filterTeacher = async (fTeacher) => {
        // console.log("filterTeacher", fTeacher);
        // fTeacher = fTeacher.trim();
        await setTeacherFiltered(fTeacher || "");
        filterTable(fTeacher, classFiltered, subjectFiltered);
    }
    const filterSubject = async (fSubject) => {
        // console.log("filterSubject", fSubject);
        // fSubject = fSubject.trim();
        await setSubjectFiltered(fSubject || "");
        filterTable(teacherFiltered, classFiltered, fSubject);
    }
    const filterCls = async (fCls) => {
        // console.log("filterCls", fCls);
        // fCls = fCls.trim();
        await setClassFiltered(fCls || "");
        filterTable(teacherFiltered, fCls, subjectFiltered);
    }


    const filterTable = async (fTeacher, fClass, fSubject) => {
        // console.log("filterTable fTeacher", fTeacher, ", fClass", fClass, ", fSubject", fSubject);
        // console.log("lstEligibility", lstEligibility);
        // Reset the filtered list to the original list
        fTeacher = fTeacher.trim();
        fClass = fClass.trim();
        fSubject = fSubject.trim();
        let lstFiltered = lstEligibility;

        // Filter by teacher name
        if (fTeacher && fTeacher !== '') {
            lstFiltered = lstFiltered
                .filter(item =>
                    item.lstTeacher?.some(obj =>
                        obj.toLowerCase().includes(fTeacher.toLowerCase()))
                )
                .map(item => ({
                    ...item,
                    lstTeacher: item.lstTeacher.filter(obj =>
                        obj.toLowerCase().includes(fTeacher.toLowerCase())
                    )
                }));
        }
        // Filter by class section
        if (fClass && fClass !== "") {
            lstFiltered = lstFiltered.filter(item =>
                item.clsSection.toLowerCase() == fClass.toLowerCase()
            );
        }
        // Filter by subject
        if (fSubject && fSubject !== "") {
            lstFiltered = lstFiltered.filter(item =>
                item.subject.toLowerCase().includes(fSubject.toLowerCase())
            );
        }
        // console.log("lstFiltered", lstFiltered);
        await setLstEligibilityFiltered(lstFiltered);
    };



    const colgrp = <colgroup>
        {/* <col width="5%"></col> */}
        <col width="5%"></col>
        <col width="10%"></col>
        <col width="6%"></col>
        <col width="5%"></col>
        <col width="20%"></col>
    </colgroup>

    function generateRandomNo() {
        var lRandNo = Math.floor(Math.random() * 999999);
        setRandNo(lRandNo)
    }

    const updateKey = () => {
        generateRandomNo();
        getEligibilityReport();
    }

    return (
        <div >
            <Header />
            <ToastContainer autoClose={3000} hideProgressBar />
            <Loader loader={loader} position="fixed" />
            <div className="col-md-12 col-xs-12 col-centered padding-remove"
                style={{
                    cursor: (loader === "none") ? 'pointer' : 'none',
                    pointerEvents: (loader === "none") ? 'auto' : 'none',
                    opacity: opacity
                }}>
            </div >
            <div className="col-sm-8 col-centered" style={{ marginTop: '2%' }}>
                <div className="col-sm-11" style={{ height: '100%' }}>
                    <div style={{ pointerEvents: loader === "none" ? "auto" : "none" }}>
                        <table className='tableLayout1'>

                            {colgrp}
                            <thead>
                                <tr>
                                    <th className="hidden">Id</th>
                                    <th> <input
                                        type="text"
                                        className="form-control inp-search"
                                        value={classFiltered}
                                        onChange={(e) => filterCls(e.target.value)}
                                        name="class"
                                        placeholder="Class"
                                    /></th>
                                    <th><input
                                        type="text"
                                        className="form-control inp-search"
                                        value={subjectFiltered}
                                        onChange={(e) => filterSubject(e.target.value)}
                                        name="subject"
                                        placeholder="Subject"
                                    /></th>
                                    <th>Periods</th>
                                    <th>Count</th>
                                    <th><input
                                        type="text"
                                        className="form-control inp-search"
                                        value={teacherFiltered}
                                        onChange={(e) => filterTeacher(e.target.value)}
                                        name="teacher"
                                        placeholder="Eligible Teacher"
                                    /></th>
                                </tr>
                            </thead>
                        </table>
                        <div className='tablebodyWrapper'>
                            <table className='tableLayout'>
                                {colgrp}
                                <tbody id="teacherReportTable">
                                    {lstEligibilityFiltered && lstEligibilityFiltered.length > 0 ? (
                                        lstEligibilityFiltered.map((obj) => {
                                            const numSections = obj.lstTeacher?.length || 0;

                                            return (
                                                <React.Fragment key={obj.sectionId + "_" + obj.subjectId}>
                                                    {/* Main row */}
                                                    <tr>
                                                        <td rowSpan={numSections || 1} className="text-left">
                                                            {obj.clsSection || ""}
                                                        </td>
                                                        <td rowSpan={numSections || 1} className="text-left">
                                                            {obj.subject || ""}
                                                        </td>
                                                        <td rowSpan={numSections || 1} className="text-right">
                                                            {obj.totalPeriods || 0}
                                                        </td>
                                                        <td rowSpan={numSections || 1} className="text-center">
                                                            {obj.countTeachers || 0}
                                                        </td>

                                                        {numSections > 0 ? (
                                                            <>
                                                                {/* first sub row */}
                                                                <td className="text-left">{obj.lstTeacher[0] || ""}</td>
                                                            </>
                                                        ) : (
                                                            <>
                                                                {/* Empty row for main row without teacher */}
                                                                <td className="text-center">

                                                                </td>
                                                            </>
                                                        )}
                                                    </tr>

                                                    {/* Sub rows */}
                                                    {numSections > 1 &&
                                                        obj.lstTeacher.slice(1).map((objTch, index) => (
                                                            <tr key={`${obj.tchId}-${index}`}>
                                                                <td className="text-left">{objTch || ""}</td>
                                                            </tr>
                                                        ))}
                                                </React.Fragment>
                                            );
                                        })
                                    ) :
                                        null
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div >
                </div>
                <div className="col-sm-1 padding-remove">
                    <UploadEligibility
                        eligibilityExcelFile={eligibilityExcelFile}
                        setEligibilityExcelFile={setEligibilityExcelFile}
                        setLoader={setLoader}
                        setOpacity={setOpacity}
                        updateKey={updateKey}
                    />
                </div >
            </div>
        </div>
    )
}

export default EligibilityReport